import React from "react";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { get } from "../../../actions/general";
import { Container } from "./styles";
import { IProps } from "./interfaces";
import messages from "./messages";

function downloadURI(uri: string, name: string) {
    const link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const DownloadCSV = ({ homeworkId, title }: IProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const handleDownloadCSV = () => {
        const timezoneOffset = -new Date().getTimezoneOffset();
        dispatch(get(`homework-results-csv/${homeworkId}/${timezoneOffset}`, (data) => {
            downloadURI(`data:text/csv;charset=utf-16,\uFEFF${encodeURIComponent(data.data)}`, `${title}.csv`)
        }));
    }
    return (
        <Container>
            <button className="button" onClick={handleDownloadCSV}>{formatMessage(messages.downloadCSV)}</button>
        </Container>
    );
};

export default DownloadCSV;
